import { Skeleton } from '@/_config/lib/react-native-skeleton';
import gridStyles from '../deliveries-grid/deliveries-grid.module.scss';

const SKELETON_CARDS = 10;
const CARD_HEIGHT = 166;

interface CardsSkeletonProps {
  count?: number;
}

export function CardsSkeleton({ count = SKELETON_CARDS }: CardsSkeletonProps) {
  return (
    <div className={gridStyles.grid} aria-busy="true">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} height={CARD_HEIGHT} borderRadius={16} />
      ))}
    </div>
  );
}
